module.exports = __webpack_public_path__ + "c7960d11e488c3467d1eae6a8094decd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/t_mobile_usa_2023_chart.png
// module id = 1741
// module chunks = 0